import React, { useState, useEffect } from 'react';
import { verificationAPI } from '../api/verificationAPI';
import { API_ORIGIN } from '../config/runtime';
import AdminTokenStats from '../components/AdminTokenStats';

const AdminPage: React.FC = () => {
  const [pendingVerifications, setPendingVerifications] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => { loadData(); }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      const res = await verificationAPI.getPendingList();
      setPendingVerifications(res.data || []);
    } catch (err: any) {
      setError(err.response?.data?.message || '데이터 로드 실패');
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (id: number) => {
    try {
      await verificationAPI.approve(id);
      alert('승인되었습니다.');
      loadData();
    } catch (err: any) { alert(err.response?.data?.message || '실패'); }
  };

  const handleReject = async (id: number) => {
    const reason = window.prompt('거절 사유:');
    if (!reason) return;
    try {
      await verificationAPI.reject(id, reason);
      alert('거절되었습니다.');
      loadData();
    } catch (err: any) { alert(err.response?.data?.message || '실패'); }
  };

  return (
    <div style={{ maxWidth: 1200, margin: '40px auto', padding: '20px' }}>
      <h1>⚙️ 관리자 페이지</h1>

      <h2 style={{ margin: '20px 0 15px' }}>📊 AI 분석 토큰 사용량</h2>
      <AdminTokenStats />

      <h2 style={{ margin: '30px 0 15px' }}>🔐 전문가 인증 관리 ({pendingVerifications.length}건 대기)</h2>

      {error && (
        <div style={{ padding: '12px', backgroundColor: '#f8d7da', borderRadius: '8px', color: '#dc3545', marginBottom: '20px' }}>
          {error}
        </div>
      )}

      {loading ? (
        <div style={{ textAlign: 'center', padding: '60px' }}>로딩중...</div>
      ) : pendingVerifications.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px', color: '#666', backgroundColor: '#f8f9fa', borderRadius: '12px' }}>
          대기중인 인증 요청이 없습니다.
        </div>
      ) : (
        <div style={{ display: 'grid', gap: '15px' }}>
          {pendingVerifications.map(v => (
            <div key={v.id} style={{ padding: '20px', backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #e9ecef' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div>
                  <div style={{ fontWeight: '700', marginBottom: '5px' }}>{v.nickname} ({v.name})</div>
                  <div style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>{v.email}</div>
                  <div style={{ fontSize: '14px' }}>
                    <div>입력 회사명: <strong>{v.user_input_company}</strong></div>
                    {v.extracted_company && <div>OCR 추출: <strong>{v.extracted_company}</strong></div>}
                    <div>매칭률: <strong style={{ color: v.match_score >= 80 ? '#28a745' : '#dc3545' }}>{v.match_score}%</strong> <span style={{ color: '#999', fontSize: '12px' }}>(참고용 — 최종 판단 근거 아님)</span></div>
                    <div>보험종류/가입기간: <strong>{v.insurance_type || '-'}</strong> · {v.period_start || '-'} ~ {v.period_end || '재직중'}</div>
                    <div>
                      문서확인번호: <strong>{v.doc_confirm_number || '(추출 실패 — 서류에서 육안 확인 필요)'}</strong>
                      {v.doc_confirm_number && (
                        <button
                          onClick={() => { navigator.clipboard?.writeText(v.doc_confirm_number); }}
                          style={{ marginLeft: '6px', padding: '1px 6px', fontSize: '12px', border: '1px solid #ccc', borderRadius: '4px', background: '#fff', cursor: 'pointer' }}
                          title="문서확인번호 복사"
                        >복사</button>
                      )}
                    </div>
                    <div style={{ marginTop: '4px', color: '#999', fontSize: '12px' }}>제출일: {v.created_at ? new Date(v.created_at).toLocaleString() : '-'}</div>
                  </div>
                  <div style={{ display: 'flex', gap: '12px', marginTop: '10px', flexWrap: 'wrap' }}>
                    {v.document_url && (
                      <a href={`${API_ORIGIN}${v.document_url}`} target="_blank" rel="noopener noreferrer"
                        style={{ color: '#007bff', fontSize: '14px' }}>
                        📄 서류 보기
                      </a>
                    )}
                    <a href="https://www.gov.kr/mw/EgovPageLink.do?link=confirm%2FAA040_confirm_id" target="_blank" rel="noopener noreferrer"
                      style={{ color: '#6f42c1', fontSize: '14px' }}
                      title="위 문서확인번호를 복사해서 정부24 페이지에 직접 입력·조회하세요">
                      🏛️ 정부24 진위확인 바로가기
                    </a>
                  </div>
                  <div style={{ marginTop: '10px', padding: '8px 10px', background: '#fff8e1', borderRadius: '6px', fontSize: '12px', color: '#8a6d00' }}>
                    ✅ 승인 전 확인: ① 서류 원본 양식·글자가 자연스러운지 육안 확인 → ② 위 문서확인번호를 정부24 진위확인에서 직접 조회해 실제 발급 문서인지 확인 → ③ 가입기간·보험종류가 신청 내용과 일치하는지 확인. 매칭률은 참고 지표일 뿐, 최종 승인 근거는 정부24 조회 결과입니다.
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button onClick={() => handleApprove(v.id)}
                    style={{ padding: '8px 16px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600' }}>
                    승인
                  </button>
                  <button onClick={() => handleReject(v.id)}
                    style={{ padding: '8px 16px', backgroundColor: '#dc3545', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600' }}>
                    거절
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminPage;
